import { render, staticRenderFns } from "./wy-interactions-phrase-categories-page.vue?vue&type=template&id=48184dae&"
import script from "./wy-interactions-phrase-categories-page.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-phrase-categories-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports